import AddIcon from '@clearkit/icons/glyphs/Add';
import { CKBox, CKButton } from 'clearkit';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import styles from './styles';

function articleForTitle(title) {
  return title.match(/^(a|e|i|o|u|h)/i) ? 'an' : 'a';
}

function AddPlanPanel({
  classes,
  title,
  description,
  destinations,
  footerIcons,
  footerDescription,
}) {
  const to = {
    pathname: `destinations/contact-success/${title.toLowerCase()}`,
  };

  return (
    <CKBox className="p-4">
      <div className={classes.header}>
        <div className={classes.titleContainer}>
          <span className={classes.title}>
            Add {articleForTitle(title)} {title} plan to your Clearbit account
          </span>
          <span className={classes.subTitle}>{description}</span>
        </div>
        <CKButton
          classes={{
            root: classes.destinationButton,
          }}
          as={Link}
          to={to}
          variant="bold"
          variantColor="blue">
          Contact success team
        </CKButton>
      </div>
      <hr className={classes.separator} />
      <div className={classes.grid}>
        {destinations.map((destination) => (
          <div key={destination.name} className={classes.destinationItem}>
            {destination.icon}
            <div className={classes.destinationTitleContainer}>
              <span className={classes.destinationTitle}>
                {destination.name}
              </span>
              <span className={classes.destinationSubtitle}>
                {destination.description}
              </span>
            </div>
          </div>
        ))}
      </div>

      {footerIcons && (
        <>
          <hr className={classes.separator} />
          <div className={classes.footer}>
            {footerIcons.map((Icon, index) => (
              <Fragment key={index}>
                {index !== 0 && <AddIcon className="text-gray-500" />}
                <Icon className={classes.footerServiceIcon} />
              </Fragment>
            ))}

            <span className={classes.footerText}>{footerDescription}</span>
          </div>
        </>
      )}
    </CKBox>
  );
}

export default withStyles(styles)(AddPlanPanel);
